export const goodsAdapter = module => {
  module.isGoodsGroup = module.moduleName === 'mc_goods_group'
  module.isBillionGoodsGroup = module.moduleName === 'mc_billion_goods_group'
  module.moduleName = 'goods'
  module.style.is = module.style.is || 6
  return module
}
